import { BaseEntity } from '@base-entities';
import { AdvanceTemplateTransformer } from '../transformers';
import { AdvanceTemplateTransformerRepository } from '../repositories';

export function makeAdvanceTemplateTransformer<
  E extends BaseEntity = BaseEntity,
>(): AdvanceTemplateTransformerRepository<E> {
  return new AdvanceTemplateTransformer<E>();
}
